import {
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

import availableOrderStatuses from '@/helpers/availableOrderStatuses'
import availableJobStatuses from '@/helpers/availableJobStatuses'
import availableEventCategories from '@/helpers/availableEventCategoriesHelper'

export default function () {
    return {
        event: {
            order: {}
        },
        eventDatesFields: [
            {
                key: 'day',
                label: 'Dia'
            },
            {
                key: 'start',
                label: 'Início'
            },
            {
                key: 'end',
                label: 'Fim'
            }
        ],
        eventJobFields: [
            {
                key: 'id',
                label: 'ID'
            },
            {
                key: 'type',
                label: 'Função'
            },
            {
                key: 'name',
                label: 'Profissional'
            },
            {
                key: 'fee',
                label: 'Valor do Job'
            },
            {
                key: 'feeTax',
                label: 'Taxa Sympla Play'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'changeStatus',
                label: 'Alterar status'
            }
        ],
        eventPaymentFields: [
            {
                key: 'description',
                label: 'Pagamento'
            },
            {
                key: 'amount',
                label: 'Valor'
            }
        ],
        jobStatuses: {
            0: 'Aguardando aceite',
            1: 'Aceito',
            2: 'Recusado',
            3: 'Cancelado pelo contratante',
            4: 'Não respondido',
            5: 'Data conflitante com outro job aceito',
            6: 'Data bloqueada pelo prestador',
            7: 'Cancelado pelo contratante após o aceite do prestador',
            8: 'Cancelado pelo prestador após o aceite'
        },
        eventStatusLabels: {
            'creating': 'Em criação',
            'pending_payment': 'Aguardando pagamento',
            'paid': 'Pago',
            'cancelled': 'Cancelado'
        },
        jobTypes: [
            ...availableCastingJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes,
            ...availableMasterOfCeremoniesJobTypes
        ],
        availableOrderStatuses,
        availableJobStatuses,
        availableEventCategories,
        showConfirmationModal: false,
        showCategoryUpdatedModal: false,
    }
}
